exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.contenedor-jefe[data-v-474a10a4]{-webkit-box-shadow:0px 0px 30px 5px rgba(50,207,255,0.733);box-shadow:0px 0px 30px 5px rgba(50,207,255,0.733)\n}\n", "", {"version":3,"sources":["/app/src/components/admin/reportes_lista_personal/components/EstructuraUnidad.vue"],"names":[],"mappings":";AA2HA,kCACE,2DAAA,kDAAsD;CACvD","file":"EstructuraUnidad.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.contenedor-jefe {\n  box-shadow: 0px 0px 30px 5px rgba(50, 207, 255, 0.733);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-474a10a4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/reportes_lista_personal/components/EstructuraUnidad.vue
// module id = uZFT
// module chunks = 0